"use server";

import { revalidatePath, revalidateTag } from "next/cache";
import { redirect } from "next/navigation";

const isValidReturnTo = (path?: string | null): path is string => {
  if (!path) return false;
  return path.startsWith("/") && !path.includes("//") && !path.includes("\\");
};

export default async function postLogout(returnTo?: string) {
  revalidatePath("/");
  if (isValidReturnTo(returnTo)) {
    redirect(`/login?returnTo=${encodeURIComponent(returnTo)}`);
  }
  redirect("/login");
}

export const revalidatePathAction = async (path: string) => {
  revalidatePath(path);
};

export const revalidateTagAction = async (tag: string) => {
  revalidateTag(tag, "max");
};
